export enum VisualSearchProviders {
  PIMEYES = "PIMEYES",
  TINEYE = "TINEYE",
  BING = "BING"
}

export enum By {
  URL = "URL",
  Base64 = "base64"
}

export enum VisualSearchActions {
  setProvider = "SET_PROVIDER",
  setThumbnail = "SET_THUMBNAIL",
  setFace = "SET_FACE",
  setFaces = "SET_FACES",
  setLoading = "SET_LOADING",
  setFaceLoading = "SET_FACE_LOADING",
  setFetchingData = "SET_FETCHING_DATA",
  setImages = "SET_IMAGES",
  addImages = "ADD_IMAGES",
  toggleProviderModal = "TOGGLE_PROVIDER_MODAL",
  toggleFaceModal = "TOGGLE_FACE_MODAL",
  error = "ERROR",
  reset = "RESET"
}

interface IVisualSearchImage {
  imageUrl: string;
  page: string;
  face?: string;
  similarity?: string;
  width?: number;
  height?: number;
}

export interface IProviderParams {
  provider: VisualSearchProviders;
  images: IVisualSearchImage[];
  removeInvalidImage: (evt: any) => void;
  isFetchingData: boolean;
}

export interface IVisualSearchProps {
  image: string;
  location?: any;
  children: (providerParams: IProviderParams) => React.SFC;
}

export interface IVisualSearchState {
  thumbnail: string;
  by: By;
  providerModalToggle: boolean;
  faces: Array<{ id: string; image: string }>;
  images: IVisualSearchImage[];
  selectedFace: string;
  isLoading: boolean;
  isFaceLoading: boolean;
  isFetchingData: boolean;
  offset: number;
  total: number;
  showFaceModal: boolean;
  error: string;
}

export const initialVisualSearchState: IVisualSearchState = {
  thumbnail: "",
  by: By.Base64,
  providerModalToggle: false,
  faces: [],
  images: [],
  selectedFace: "",
  isLoading: false,
  isFaceLoading: false,
  isFetchingData: false,
  offset: 0,
  total: 0,
  showFaceModal: false,
  error: ""
};



// WEBPACK FOOTER //
// ./src/share/types/visualSearch.ts